<script setup>
  import { ExChip } from "@extracadabra/ui-kit";
  import { computed } from "vue";
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();

  const props = defineProps({
    applicantsNumber: {
      type: Number,
    },
  });

  const applicantChip = computed(() => {
    const { applicantsNumber } = props;
    let label = t("CANDIDATES.PAGES.OFFERS.@FIRST_APPLICANTS");
    // Default values when applicantsNumber is under or equal to 5
    let color = "positive";
    let iconName = "medal";

    if (applicantsNumber > 5 && applicantsNumber <= 9) {
      label = t("CANDIDATES.PAGES.OFFERS.@APPLY_NUMBER", { count: applicantsNumber });
      color = "primary";
      iconName = "ranking-star";
    } else if (applicantsNumber > 9 && applicantsNumber <= 20) {
      label = t("CANDIDATES.PAGES.OFFERS.@APPLY_NUMBER", { count: applicantsNumber });
      color = "secondary";
      iconName = "user-group";
    } else if (applicantsNumber > 20) {
      label = t("CANDIDATES.PAGES.OFFERS.@MUCH_APPLY_NUMBER");
      color = "accent";
      iconName = "people-group";
    }

    return { label, color, iconName };
  });
</script>
<template>
  <ExChip :label="applicantChip.label" :color="applicantChip.color" :icon-name="applicantChip.iconName" />
</template>
